// extracted by mini-css-extract-plugin
module.exports = {"ErrorHolder":"scss_ErrorHolder__3oMl3"};